module.exports = __webpack_public_path__ + "img/newicon10on.9b8a565f.svg";